import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=78e4d6cd&"
import script from "./SidebarLink.vue?vue&type=script&lang=ts&"
export * from "./SidebarLink.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports